import React, { Component } from 'react';
import t from '../../../utils/translations';

export class InputGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
    };

    this.handleChange = this.handleChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.placeholder !== nextProps.placeholder) {
      this.setState({ value: nextProps.placeholder || '0' });
    }
  }

  handleChange(e) {
    let value = e.target.value;

    if (this.props.max && value) {
      value = Number(value) >= this.props.max ? this.props.max : value;
    }

    if (isNaN(value)) {
      return;
    }

    this.setState({ value }, () => {
      if (this.props.onChange) {
        this.props.onChange({
          name: this.props.name,
          value: this.state.value,
        });
      }
    });
  }

  render() {
    return (
      <div className="form-group">
        <label htmlFor={this.props.id} className="form-label">{t(this.props.label)} <span className="required">*</span></label>
        <div className="input-group">
          <input id={this.props.id}
                 className="form-control text-right"
                 name={this.props.name}
                 placeholder={t(this.props.placeholder)}
                 onChange={this.handleChange}
                 value={this.state.value}
                 aria-describedby={this.props.id}
          />
          <div className="input-group-append">
            <span className="input-group-text" id={this.props.id}>{t(this.props.suffix)}</span>
          </div>
        </div>
      </div>
    );
  }
}
